import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';

// import playOnline from 'screens/lobby/store/reducer'
// import connections from 'screens/profile/connections/store/reducer'
// import commonActionReducer from 'screens/commonAction/Reducer'
// import ludoboardReducer from 'screens/gameplay/store/reducer'
import appReducer from './reducers/appReducer'
// import user from './reducers/user'
import gameplay from './reducers/gameplay'
import ludoboardReducer from './reducers/ludoboardReducer';
// import pawReducer from 'screens/home/screenWidgets/predictWinV2/store/reducer'

const middlewares = [thunk]

// Persist configuration
const persistConfig = {
  key: 'root', // Key used in storage (localStorage)
  storage, // Default to localStorage
  whitelist: ['user', 'gameplay', 'appReducer'], // Reducers to persist
  blacklist: ['playOnline', 'commonActionReducer'], // Reducers to exclude from persistence
};

// if (__DEV__) {
//   const createDebugger = require('redux-flipper').default
//   middlewares.push(createDebugger())
// }

// Combine reducers
const rootReducer = combineReducers({
  appReducer,
  // user,
  // playOnline,
  gameplay,
  // commonActionReducer,
  // connections,
  ludoboard: ludoboardReducer,
  // pawReducer,
});

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store with persisted reducer
const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(...middlewares))
);

// Persistor for persisting the store
const persistor = persistStore(store);

const clearPersistedStore = () => {
  // Clear the persisted store
  persistor.purge();
  // You might also want to dispatch a reset action to clear the in-memory store
  store.dispatch({ type: 'RESET_STORE' });
};

export { store, persistor, clearPersistedStore };
